import { render, staticRenderFns } from "./PanelistsPage.vue?vue&type=template&id=ccecbe46"
import script from "./PanelistsPage.vue?vue&type=script&lang=ts"
export * from "./PanelistsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports